module.exports = __webpack_public_path__ + "img/0404E8_0404B5_0404CB_3333FC-256px.6b46783d.png";